/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GuaranteeInsuredRisk } from '../models/GuaranteeInsuredRisk';
import type { PatchedGuaranteeInsuredRisk } from '../models/PatchedGuaranteeInsuredRisk';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class GuaranteesService {

  /**
   * "Riscurile asigurate" text of each blank — list, retrieve, patch, preview.
 *
 * Neither created nor deleted: the rows are the guarantee types on sale. The text is HTML and may
 * use the ``{variable}`` placeholders the ``variables`` field lists; ``preview`` prints the blank
 * on sample data so the result can be seen before it reaches a policy.
   * @param ordering Ordering fields: guarantee_type
   * @returns GuaranteeInsuredRisk 
   * @throws ApiError
   */
  public static guaranteesInsuredRisksList(
ordering?: string,
): CancelablePromise<Array<GuaranteeInsuredRisk>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/guarantees/insured-risks/',
      query: {
        'ordering': ordering,
      },
    });
  }

  /**
   * "Riscurile asigurate" text of each blank — list, retrieve, patch, preview.
 *
 * Neither created nor deleted: the rows are the guarantee types on sale. The text is HTML and may
 * use the ``{variable}`` placeholders the ``variables`` field lists; ``preview`` prints the blank
 * on sample data so the result can be seen before it reaches a policy.
   * @param guaranteeType A unique value identifying this guarantee insured risk.
   * @returns GuaranteeInsuredRisk 
   * @throws ApiError
   */
  public static guaranteesInsuredRisksRetrieve(
guaranteeType: string,
): CancelablePromise<GuaranteeInsuredRisk> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/guarantees/insured-risks/{guarantee_type}/',
      path: {
        'guarantee_type': guaranteeType,
      },
    });
  }

  /**
   * "Riscurile asigurate" text of each blank — list, retrieve, patch, preview.
 *
 * Neither created nor deleted: the rows are the guarantee types on sale. The text is HTML and may
 * use the ``{variable}`` placeholders the ``variables`` field lists; ``preview`` prints the blank
 * on sample data so the result can be seen before it reaches a policy.
   * @param guaranteeType A unique value identifying this guarantee insured risk.
   * @param requestBody 
   * @returns GuaranteeInsuredRisk 
   * @throws ApiError
   */
  public static guaranteesInsuredRisksPartialUpdate(
guaranteeType: string,
requestBody?: PatchedGuaranteeInsuredRisk,
): CancelablePromise<GuaranteeInsuredRisk> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/guarantees/insured-risks/{guarantee_type}/',
      path: {
        'guarantee_type': guaranteeType,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * GET .../{guarantee_type}/preview/ — the blank of this type, rendered on sample data.
   * @param guaranteeType A unique value identifying this guarantee insured risk.
   * @returns binary 
   * @throws ApiError
   */
  public static guaranteesInsuredRisksPreviewRetrieve(
guaranteeType: string,
): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/guarantees/insured-risks/{guarantee_type}/preview/',
      path: {
        'guarantee_type': guaranteeType,
      },
    });
  }

}
